import { useSettings } from "@/hooks/useSettings";

const MESSAGE = "I'd like to discuss your products";

export default function GymGearFab() {
  const { whatsapp_gymgear } = useSettings();
  const digits = (whatsapp_gymgear || "").replace(/\D/g, "") || "380759878825";
  const href = `https://wa.me/${digits}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Gym Gear on WhatsApp"
      data-testid="gymgear-fab"
      className="gymgear-fab group fixed z-50 bottom-5 left-5 sm:bottom-6 sm:left-6 inline-flex items-center select-none"
    >
      <span className="gymgear-pill flex items-center justify-center h-11 sm:h-12 px-5 sm:px-6 rounded-full bg-black">
        <span
          className="font-black uppercase tracking-[0.12em] text-[#39FF14] text-sm sm:text-base leading-none"
          style={{ textShadow: "0 0 10px rgba(57,255,20,0.65), 0 0 22px rgba(57,255,20,0.35)" }}
        >
          Gym Gear
        </span>
      </span>
    </a>
  );
}
